import React, {useEffect, useState} from "react";
import styles from "./your-birthdate.module.css";
import {Page} from "../../components/page/page";
import {DateTimeButton} from "../../../../components/date-time-button/date-time-button";
import {useDispatch, useSelector} from "react-redux";
import {setBirthDate, setZodiacSign} from "../../store/stateSlice";
import {updateProfile} from "../../../../api";
import {isValidDate} from "../../../../util";
import { ReactComponent as CircleImg } from '../../images/circle.svg';
import { findZodiacSign } from "src/shared/utils/find-zodiac-sign";


const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

const range = (start, end) =>
    Array.from({length: end - start}, (v, k) => k + start);

const YourBirthdatePage = () => {
    const state = useSelector((store) => store.predictions);
    const dispatch = useDispatch();
    const [selectedDay, selectDay] = useState(state.birthDate.day || "day");
    const [selectedMonth, selectMonth] = useState(
        state.birthDate.month || "month"
    );
    const [selectedYear, selectYear] = useState(state.birthDate.year || "year");

    const [isDateValid, setDateValid] = useState(false);

    useEffect(() => {
        let isValid = selectedDay !== "day" &&
            selectedMonth !== "month" &&
            selectedYear !== "year" &&
            isValidDate(selectedYear, selectedMonth, selectedDay)
        setDateValid(isValid)
    }, [selectedDay, selectedMonth, selectedYear]);

    const dateTimeButtonStyles = {
        color: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(255, 255, 255)',
        border: '1px solid rgb(218, 218, 218)',
        fontSize: '16px',
    };

    const buttonStyles = {
        backgroundColor: "rgb(33, 51, 112)",
        fontSize: '18px',
        boxShadow: 'none',
        borderRadius: '150px',
        position: "absolute",
        bottom: "30px",
        width: "90%",
        zIndex: "5",
        maxWidth: "500px",
        boxSizing: "border-box",
        left: "20px",
        right: "20px"
    };

    const handleContinue = () => {
        const dt = {
            day: selectedDay,
            month: selectedMonth,
            year: selectedYear,
        };

        dispatch(setBirthDate(dt))
        const sign = findZodiacSign(selectedDay, selectedMonth + 1);

        dispatch(setZodiacSign(sign))

        updateProfile({
            land: "future",
            topicType: "birthDate",
            topic: "What’s your date of birth?",
            answer: {...dt, month: selectedMonth + 1}
        })
    }

    return (
        <Page
            title="What’s your date of birth?"
            nextPageLink="../your-birthtime"
            onContinue={handleContinue}
            canGoToNextPage={isDateValid}
            buttonStyles={buttonStyles}
            currentStep="9"
        >
            <p className={styles.subtitle}>We need this to determine the planetary placements at the time of your
                birth.</p>
            <div className={styles.container_page}>
                <div className={styles.date_button_container}>
                    <DateTimeButton
                        id="day"
                        value={selectedDay}
                        onChange={(e) => selectDay(parseInt(e.target.value))}
                        dateTimeButtonStyles={dateTimeButtonStyles}
                    >
                        <option value="day" hidden>
                            Day
                        </option>
                        {[...Array(31)].map((el, i) => (
                            <option key={i} value={i + 1} selected>
                                {i + 1}
                            </option>
                        ))}
                    </DateTimeButton>
                </div>
                <div className={styles.date_button_container}>
                    <DateTimeButton
                        id="month"
                        value={months[selectedMonth]}
                        onChange={(e) => selectMonth(months.indexOf(e.target.value))}
                        dateTimeButtonStyles={dateTimeButtonStyles}
                    >
                        <option value="month" hidden>
                            Month
                        </option>
                        {months.map((el, i) => (
                            <option key={i} value={el}>
                                {el}
                            </option>
                        ))}
                    </DateTimeButton>
                </div>
                <div className={styles.date_button_container}>
                    <DateTimeButton
                        id="year"
                        value={selectedYear}
                        onChange={(e) => selectYear(parseInt(e.target.value))}
                        dateTimeButtonStyles={dateTimeButtonStyles}
                    >
                        <option value="year" hidden>
                            Year
                        </option>
                        {[...range(1940, 2024)].reverse().map((el, i) => (
                            <option key={i} value={el}>
                                {el}
                            </option>
                        ))}
                    </DateTimeButton>
                </div>
                {(
                        selectedDay !== "day" &&
                        selectedMonth !== "month" &&
                        selectedYear !== "year" &&
                        !isValidDate(selectedYear, selectedMonth, selectedDay)) &&
                    <span className={styles.error_text}>Please enter a valid date</span>}
            </div>
            <CircleImg className={styles.page_image} width="100%" height="100%" />
            
        </Page>
    );
};

export {YourBirthdatePage};
